module.exports = global["reqwest"] = require("-!/home/runner/work/consumer/consumer/node_modules/babel-loader/lib/index.js??ref--4!./reqwest.min.js");